export default __webpack_public_path__ + "static/media/Hyperscience.19caefd7.png";